import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import React, {forwardRef, useImperativeHandle, useRef} from 'react'
import {SystemRole} from '../../../Constants'
import {useAppConfig} from '../../../context/app/AppContext'
import {useUserHospital} from '../../../context/hospital/UserHospitalContext'
import {useAuth} from '../../authentication/AuthProvider'
import {useListPatients} from '../../patient/query-keys/PatientKeysManager'
import StyledDropdown from '../components/StyledDropdown'

const StyledPatientOptions = forwardRef(
    (
        {value = null, onChange = () => {}, placeholder = 'Select a Patient'},
        ref,
    ) => {
        useSignals()

        useImperativeHandle(ref, () => ({
            getValue: () => handleGetValue(),
            changeValue: newValue => handleChangeValue(newValue),
        }))

        //#region Context
        const {user} = useAuth()
        const {userRole} = useAppConfig()
        const {currentHospital} = useUserHospital()
        //#endregion

        //#region Value
        const selectedItem = useSignal(value)
        const optionRef = useRef(null)

        const handleGetValue = () => {
            return optionRef.current?.getValue()
        }

        const handleChangeValue = newValue => {
            optionRef.current?.changeValue(newValue)
        }

        const onItemChange = selectedItemId => {
            const item = options.find(option => option.value === selectedItemId)

            selectedItem.value = item

            if (onChange) {
                onChange(item)
            }
        }
        //#endregion

        //#region Dropdown
        const {data: options} = useListPatients(
            user?.id,
            null,
            true,
            userRole === SystemRole.ADMIN
                ? {}
                : {hospitalId: currentHospital?.id},
            !!user?.id &&
                userRole === SystemRole.USER_WITH_ROLE &&
                !!currentHospital?.id,
        )

        const valueTemplate = (option, props) => {
            if (option) {
                return (
                    <div className="flex align-items-center">
                        <i
                            className="pi pi-user-plus mr-2"
                            style={{fontSize: '16px'}}></i>

                        <div className="font-bold">
                            {option.label}{' '}
                            {option?.data ? ` - ${option.data}` : ''}
                        </div>
                    </div>
                )
            }

            return <span>{props.placeholder}</span>
        }

        const itemTemplate = option => {
            return (
                <div className="flex align-items-center">
                    <div
                        className="flex align-items-center justify-content-center mr-2"
                        style={{width: '48px'}}>
                        <div>
                            <i
                                className="pi pi-user-plus"
                                style={{fontSize: '20px'}}></i>
                        </div>
                    </div>
                    <div>
                        <h6 className="m-0 mb-1 font-bold">{option.label}</h6>
                        <small>{option?.data}</small>
                    </div>
                </div>
            )
        }
        //#endregion

        return (
            <React.Fragment>
                <div className="col-12">
                    <StyledDropdown
                        ref={optionRef}
                        options={options || []}
                        value={value}
                        onChange={onItemChange}
                        placeholder={placeholder}
                        itemTemplate={itemTemplate}
                        valueTemplate={valueTemplate}
                        showClear={true}
                        hasPanelFooter={true}
                    />
                </div>
            </React.Fragment>
        )
    },
)

export default StyledPatientOptions
